import { MODEL_KEY } from '../../../../modules/model/constants'

const ABOUT_MODEL_CLASS_NAME = 'About'

const ABOUT_MODEL_KEY = {
  ...MODEL_KEY,

  BIO: 'bio',
  YEARS_OF_EXPERIENCE: 'yearsOfExperience',

  WELCOME_MEDIA_ID: 'welcomeMediaId',
  COVER_MEDIA_ID: 'coverMediaId',
  WELCOME_MEDIA_TITLE: 'welcomeMediaTitle',

  INSTAGRAM: 'instagram',
  TWITTER: 'twitter',
  YOUTUBE: 'youtube',
  TIK_TOK: 'tiktok',

  // Associations
  WELCOME_MEDIA: 'welcomeMedia',
  COVER_MEDIA: 'coverMedia',
  MEDIA: 'media',

  PROFILE_ID: 'profileId'
}

export const ABOUT_MODEL_ASSOCIATION_KEYS = [
  ABOUT_MODEL_KEY.COVER_MEDIA,
  ABOUT_MODEL_KEY.WELCOME_MEDIA,
  ABOUT_MODEL_KEY.MEDIA
]

const ABOUT_MODEL_PRIVATE_KEYS = []

const ABOUT_MODEL_SCOPE = {
  /**
   * Only returns the public attributes of a `Settings`.
   * @type {Object}
   */
  defaultScope: {
    attributes: {
      exclude: ABOUT_MODEL_PRIVATE_KEYS
    }
  }
}

const ABOUT_MODEL_AUDIT = {
  CREATED: `${ABOUT_MODEL_CLASS_NAME} Created`,
  DELETED: `${ABOUT_MODEL_CLASS_NAME} Deleted`,
  UPDATED: `${ABOUT_MODEL_CLASS_NAME} Updated`
}

const ABOUT_MODEL_AUDIT_CLASS_NAME = 'AboutAudit'

export {
  ABOUT_MODEL_PRIVATE_KEYS,
  ABOUT_MODEL_KEY,
  ABOUT_MODEL_CLASS_NAME,
  ABOUT_MODEL_SCOPE,
  ABOUT_MODEL_AUDIT,
  ABOUT_MODEL_AUDIT_CLASS_NAME
}
